import { memo } from 'react'
import { usePress } from '@react-aria/interactions'
import cn from 'classnames'

import type { TileProps } from './types'

import styles from './Tile.module.scss'

/**
 * Внутренний блок карточки (правило 11): surface-alt, используется внутри Card.
 * Выбранный тайл (isSelected) — accent-градиент + тень, база для тайлов состояний главной.
 */
export const Tile = memo(function Tile(props: TileProps) {
  const { size = 'M', padding = 'M', isSelected = false, isGrow = false, onPress, children } = props

  const isPressable = Boolean(onPress)
  const { pressProps, isPressed } = usePress({ onPress, isDisabled: !isPressable })

  return (
    <div
      className={cn(
        styles.root,
        styles[`size_${size}`],
        styles[`padding_${padding}`],
        isSelected && styles.isSelected,
        isGrow && styles.isGrow,
      )}
      role={isPressable ? 'button' : undefined}
      tabIndex={isPressable ? 0 : undefined}
      data-pressed={isPressable ? isPressed : undefined}
      {...(isPressable ? pressProps : {})}
    >
      {children}
    </div>
  )
})
